import {Injectable} from '@angular/core';

@Injectable({
    providedIn: "root"
})

export class PrintPage {
    constructor() {}

   print(htmlPage: string){
    if(htmlPage.indexOf("PRINT_CONTENT") === -1) {
        throw new Error('print input malformed');
    }
    const popupWin = window.open("", "_blank", "top=0,left=0,height=100%,width=auto");
    popupWin.document.open();
    const content = htmlPage.replace(
      "PRINT_CONTENT",
      "window.print();window.close()"
    );
    popupWin.document.write(content);
    popupWin.document.close();
   }
}
